import { useEffect } from 'react';

interface Props {
  getWarehouseProductsForSelectionHandler: () => Promise<void>;
}

export const useWarehouseSourceOperationEffects = ({
  getWarehouseProductsForSelectionHandler,
}: Props) => {
  useEffect(() => {
    getWarehouseProductsForSelectionHandler();
  }, [getWarehouseProductsForSelectionHandler]);
};
